import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return ($setup.type)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(["badge primary", $setup.getContactStatusClass($setup.type as ContactStatus)])
      }, _toDisplayString($setup.type), 3))
    : _createCommentVNode("", true)
}